/**
 * 来場者向けコンテンツの既読状態キーを構築します。
 * visitor IDと公開コンテンツversionだけを使い、認証情報は保存しません。
 */

/** 現行チュートリアルの公開コンテンツversion */
export const VISITOR_TUTORIAL_CONTENT_VERSION = "tutorial-v2";

/**
 * storageキーに含める値を安全な文字列へ変換する
 * @param value - visitor IDまたはコンテンツversion
 * @returns URLエンコード済みの値
 */
const encodeStorageKeyPart = (value: string): string =>
  encodeURIComponent(String(value ?? "").trim() || "unknown");

/**
 * チュートリアル既読キーを返す
 * @param visitorId - 来場者ID
 * @param contentVersion - チュートリアルversion
 * @returns localStorageキー
 */
export const getTutorialSeenKey = (
  visitorId: string,
  contentVersion = VISITOR_TUTORIAL_CONTENT_VERSION,
): string =>
  `@ikomasai/visitor_tutorial_seen/${encodeStorageKeyPart(visitorId)}/${encodeStorageKeyPart(contentVersion)}`;

/**
 * 投票結果既読キーを返す
 * @param visitorId - 来場者ID
 * @param contentVersion - 投票結果version
 * @returns localStorageキー
 */
export const getVotingResultsSeenKey = (
  visitorId: string,
  contentVersion: string,
): string =>
  `@ikomasai/voting_fest_results_seen/${encodeStorageKeyPart(visitorId)}/${encodeStorageKeyPart(contentVersion)}`;

/**
 * 強制表示告知の既読キーを返す
 * @param visitorId - 来場者ID
 * @param contentVersion - 告知version（運営が「見た人にも再表示する」を選んで保存すると変わる）
 * @returns localStorageキー
 */
export const getVotingAnnouncementSeenKey = (
  visitorId: string,
  contentVersion: string,
): string =>
  `@ikomasai/voting_fest_announcement_seen/${encodeStorageKeyPart(visitorId)}/${encodeStorageKeyPart(contentVersion)}`;
